import Basic from "./Basic.jsx";
import Confirmation from "./Confirmation.jsx";
import TextBox from "./TextBox.jsx";

export default {
  Basic,
  Confirmation,
  TextBox
};
